import React from "react";
import Icon from "../../common/components/Icon/Icon";

const FixedActionsLeft: React.FC = () => {
  const whatsappNumber = window.commonVariables?.whatsappNumber;

  if (!whatsappNumber) {
    return null;
  }

  // Ensure the number is clean (digits only)
  const cleanNumber = whatsappNumber.replace(/\D/g, "");
  const whatsappUrl = `https://wa.me/${cleanNumber}`;

  return (
    <div className="fixed-actions-left">
      <a
        href={whatsappUrl}
        className="whatsapp-button"
        aria-label="Contact us on WhatsApp"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Icon iconName="whatsapp-filled" className="icon--filled" />
      </a>
    </div>
  );
};

export default FixedActionsLeft;
